// extracted by mini-css-extract-plugin
module.exports = {"table":"AuctionsTable_table__Dthpn"};